import shortId from "short-uuid";

const CONTAINERS = ["ctrl-panel", "ctrl-segment"];
const INPUTS = ["ctrl-textbox"];

export const __generateData = (body, { properties, components, legacy, nsLength = 1 }) => {
    const data = {};
    const generateEmptyBody = (len) => Array(len).fill("").map(() => (legacy ? {} : { __ns: shortId.generate() }));
    const initValue = (configProperties) => {
        const defaultValue = configProperties.hasOwnProperty("nullValue") ? configProperties.nullValue() : null;

        return { value: defaultValue };
    };
    const parseBody = (parsedBody, bodyData) => {
        parsedBody.forEach(element => {
            const { guid } = element;
            const elementProperties = properties[guid];
            const configProperties = components[elementProperties.__component];
            const { get, set } = configProperties;

            if (get || set) {
                if (bodyData.constructor === Array) {
                    bodyData.forEach(entry => {
                        if (configProperties.namespace) {
                            entry[guid] = generateEmptyBody(nsLength);
                            parseBody(element.body, entry[guid]);
                        } else {
                            entry[guid] = initValue(configProperties);
                        }
                    });
                } else if (configProperties.namespace) {
                    bodyData[guid] = generateEmptyBody(nsLength);
                    parseBody(element.body, bodyData[guid]);
                } else {
                    bodyData[guid] = initValue(configProperties);
                }
            } else if (element.body && element.body.length) {
                parseBody(element.body, bodyData);
            }
        });

        return bodyData;
    };

    return parseBody(body, data);
};

const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const randomBool = () => Math.random() >= 0.5;

const getElementProperties = (elementType, guid) => {
    const properties = { component: elementType, share: randomBool() };

    if (elementType === "ctrl-panel") {
        properties.label = `Panel ${guid}`;
    } else if (elementType === "ctrl-textbox") {
        properties.label = `Textbox ${guid}`;
    } else if (elementType === "ctrl-segment") {
        properties.label = `Segment ${guid}`;
        properties.namespace = true;
    } else if (elementType === "ctrl-select") {
        properties.label = `Select ${guid}`;
        properties.options = [
            { label: "Test", value: "test" }
        ];
    }

    return properties;
};

const randomElement = () => {
    const elements = [...INPUTS, ...CONTAINERS];
    return elements[randomInt(0, elements.length - 1)];
};

const newElement = (elementType = randomElement()) => {
    const element = {
        guid: shortId.uuid()
    };
    const properties = getElementProperties(elementType, element.guid);

    if (CONTAINERS.includes(elementType)) {
        element.body = [];
    } else {
        element.get = null;
        element.set = null;
    }
    return { element, properties };
};

const randomContainer = () => CONTAINERS[randomInt(0, CONTAINERS.length - 1)];

const randomInput = () => INPUTS[randomInt(0, INPUTS - 1)];

const newContainerElement = () => newElement(randomContainer());

const newInputElement = () => newElement(randomInput());

const randomBodyFill = (sp) => Array(randomInt(1, 5))
    .fill("")
    .map(() => {
        const {
            element,
            properties
        } = newInputElement();

        // this.setProperties({ guid: element.guid, properties });
        sp({ guid: element.guid, properties });

        return element;
    });

const generateNewBody = (sp) => {
    const { element, properties } = newContainerElement();

    element.body = randomBool() ? [generateNewBody(sp)] : randomBodyFill(sp);
    sp({ properties, guid: element.guid });
    // this.setProperties({ properties, guid: element.guid });

    return element;
};

export const generateTemplate = (elements, sp) => Array(elements).fill("").map(() => generateNewBody(sp));
